import { AxiosError } from 'axios';
import { showSnackbar } from '../../context/Snackbar/SnackbarContext';
import { SnackbarType } from '../../context/Snackbar/Types';

// Errors that should be handled silently (no snackbar shown)
// These are expected errors that are handled gracefully by the calling code
const SILENT_ERROR_PATTERNS = [
  'No processed data found', // Expected when file hasn't been processed yet
];

const shouldShowErrorSnackbar = (errorMessage: string): boolean => {
  return !SILENT_ERROR_PATTERNS.some(pattern => errorMessage.includes(pattern));
};

export const handleResponseError = async (error: AxiosError) => {
  let errorMessage = 'An error occurred';

  // Extract backend error details if available
  if (error.response?.data) {
    const data = error.response.data;

    // Check for various backend error formats
    if (typeof data === 'object' && 'detail' in data) {
      errorMessage = data.detail as string;
    } else if (typeof data === 'object' && 'message' in data) {
      errorMessage = data.message as string;
    } else if (typeof data === 'string') {
      errorMessage = data;
    }
  }

  // Provide context for specific error codes
  if (error.response?.status === 502) {
    errorMessage = `Service error: ${errorMessage}. The backend service may be experiencing issues.`;
  } else if (error.response?.status === 422) {
    errorMessage = `Validation error: ${errorMessage}`;
  }

  // Only show snackbar for errors that aren't expected/handled silently
  if (shouldShowErrorSnackbar(errorMessage)) {
    showSnackbar({
      title: 'Error',
      message: errorMessage || error.message || 'An error occurred',
      type: SnackbarType.error,
    });
  }
  return Promise.reject(error);
};
